module.exports = __webpack_public_path__ + "img/bank-industry-problem-icon2.ef466011.png";